module.exports = __webpack_public_path__ + "img/nativePay.c9a31d2c.png";